export default {
    app_bar: {
        title: 'ระบบรับสมัครนักศึกษาระดับปริญญาตรี',
        title_graduate: 'ระบบรับสมัครนักศึกษาระดับบัณฑิตศึกษา',
        university_name: "สถาบันเทคโนโลยีพระจอมเกล้าเจ้าคุณทหารลาดกระบัง",
        user: 'ผู้ใช้งาน',
    },
    footer: {
        registrar: 'สำนักทะเบียนและบริการการศึกษา',
        address1: 'เลขที่ 1 ซอยฉลองกรุง 1',
        address2: 'แขวงลาดกระบัง เขตลาดกระบัง',
        address3: 'กรุงเทพ 10520',
        contact_undergraduate: 'ติดต่อ : ระดับปริญญาตรี',
        contact_graduate: 'ติดต่อ : ระดับบัณฑิตศึกษา',
        ext: "ต่อ",
    },
    login: {
        login: 'เข้าสู่ระบบ',
        register: 'ลงทะเบียน',
        forgot_password: 'รีเซ็ตรหัสผ่าน',
        email: 'E-mail',
        password: 'Password',
        forgot_password_label: 'รหัสบัตรประชาชน',
        forgot_password_hint: 'สำหรับชาวต่างชาติ กรอก เลขพาสปอร์ต',
        spam_mail_notice: '*หากไม่ได้รับอีเมลของสถาบันฯ ให้ดูที่ Junk/Spam Mail (อีเมลขยะ)',
        officer_authen: "เข้าสู่ระบบสำหรับเจ้าหน้าที่ / อาจารย์",
    },
    create_password: {
        title: 'สร้างรหัสผ่าน / รีเซตรหัสผ่าน',
        link_cannot_use: 'ลิงก์ไม่สามารถใช้งานได้ กรุณาใช้ลิงก์ล่าสุด',
        set_password: 'สร้างรหัสผ่าน',
        complete: 'สร้างรหัสผ่านเรียบร้อยแล้ว',
    },
    menu: {
        login: 'เข้าสู่ระบบ / ลงทะเบียน',
        userID: 'รหัสประชาชน / พาสปอร์ต / อีเมล',
        explore: 'ค้นหาหลักสูตร',
        explore_undergraduate: 'ค้นหาหลักสูตร | ปริญญาตรี',
        explore_graduate: 'ค้นหาหลักสูตร | บัณฑิตศึกษา',
        explore_master: 'ค้นหาหลักสูตร | ปริญญาโท',
        explore_phd: 'ค้นหาหลักสูตร | ปริญญาเอก',
        announcement_undergraduate: 'รวมประกาศ | ปริญญาตรี',
        announcement_graduate: 'รวมประกาศ | บัณฑิตศึกษา',
        create_user: 'สร้างบัญชีผู้ใช้',
        logout: 'ออกจากระบบ',
        registered_program_list: 'รายการที่สมัคร',
        applicant_info: 'ข้อมูลผู้สมัคร',
        config_year: 'ตั้งค่าปีการศึกษา',
        config_faculty_bank_account: 'ตั้งค่าบัญชีธนาคารคณะ',
        config_round: 'ตั้งค่ารอบการสมัคร',
        config_project: 'ตั้งค่าโครงการ',
        config_project_group: 'ตั้งค่ากลุ่มโครงการ',
        config_project_group_name_en: 'ชื่อกลุ่มโครงการ(อังกฤษ)',
        config_project_group_name_th: 'ชื่อกลุ่มโครงการ(ไทย)',
        config_curriculum: 'ตั้งค่าหลักสูตร',
        config_curriculum_constraint: 'ตั้งค่าเงื่อนไขของหลักสูตร',
        config_master_reg_curriculum: 'ตั้งค่า TCAS ID / Inter ของหลักสูตร',
        application_documents_guide: 'คู่มือการใช้งานระบบรับสมัคร',
        config_faculty_officer_main: 'ตั้งค่าสิทธิ์เจ้าหน้าที่คณะ',
        manual_admission_for_executor_level_1: 'คู่มือกำหนดผู้ผ่านการคัดเลือก',
        manual_admission_for_executor_level_2: 'คู่มือยืนยันผู้ผ่านการคัดเลือก',
        config_curriculum_gat_pat: 'ตั้งค่าเปอร์เซ็นต์ GAT PAT',
        move_applicant: 'แก้ไขข้อมูลใบสมัคร',
        gen_student_id_and_import_to_maticulation_system: 'นำเข้าผู้สมัคร 4+1 ลงทะเบียน ป.โท',
        gen_student_id: 'สร้างรหัสนักศึกษา',
        gen_student_id_graduate: 'นำเข้า 4+1 ลงทะเบียนรายวิชาป.โท (รายบุคคล)',
        move_to_marticulation_online: 'นำเข้าผู้สมัคร สู่ระบบรายงานตัวออนไลน์',
        search_user: 'ค้นหา / แก้ไข ข้อมูลผู้สมัคร',

        save: "บันทึก",

        applicant_info_general: 'ข้อมูลผู้สมัคร',
        applicant_info_school: 'ข้อมูลการศึกษา (โรงเรียน)',
        applicant_info_university: 'ข้อมูลการศึกษา (มหาวิทยาลัย)',
        applicant_info_medicine: 'ข้อมูลเพิ่มเติม (สำหรับคณะแพทย์)',
        applicant_info_eng_inter: 'ข้อมูลเพิ่มเติม (สำหรับนานาชาติ)',
        applicant_info_constraints: 'ข้อมูลประกอบหลักสูตรที่สมัคร',
        applicant_info_add: 'ข้อมูลเพิ่มเติม',

        questionnaire: 'แบบสอบถาม',

        number_of_applicants_report: "รายงาน",
        number_of_applicants_by_order_report: "รายงานแยกลำดับสาขา + คัดเลือก",
        number_of_applicants_passed_report: "รายงานผู้ผ่านการคัดเลือก",
        not_paid_tuition_fee: "รายงานค้างค่าธรรมเนียมการศึกษา",
    },
    explore: {
        undergraduate: 'ปริญญาตรี',
        graduate: 'บัณฑิตศึกษา',
        admission_system_undergraduate: 'ระบบรับสมัครนักศึกษาระดับปริญญาตรี',
        admission_system_master: 'ระบบรับสมัครนักศึกษาระดับปริญญาโท',
        admission_system_phd: 'ระบบรับสมัครนักศึกษาระดับปริญญาเอก',
        admission_system_graduate: 'ระบบรับสมัครนักศึกษาระดับบัณฑิตศึกษา',
        find_open_curriculum: 'ค้นหาหลักสูตรที่เปิด',
        select_faculty_to_search: 'ค้นหา คณะ / วิทยาลัย / วิทยาเขต',
        select_round_to_search: 'ค้นหา รอบรับสมัคร',
        round: 'รอบ',
        faculty_of: 'คณะ ',
        more_search_words: 'คำค้นหาเพิ่มเติม (Enter เพื่อแยกคำ) [ระบบจะค้นจากชื่อคณะ,หลักสูตร]',
        select_project_to_search: 'ค้นหา โครงการ',
        select_inter_to_search: 'ค้นหาหลักสูตร ไทย / นานาชาติ',
        popup_dialog_title: 'การแจ้งเตือน',
        popup_dialog_text: 'คณะอาจเปิดรับในรอบ Portfolio 1-1 ถึง 1-4 โปรดดูรายละเอียดการรับในรอบ Portfolio 1-1 ถึง 1-4 เพิ่มเติม',
    },
    program_list: {
        search_results: 'ผลการค้นหา',
        curriculum: 'หลักสูตร',
        list: 'รายการ',
        round: 'รอบ',
        project: 'โครงการ',
        open_date: 'วันที่เปิดรับสมัคร',
        branch: 'แขนง',
        register: 'สมัคร',
        remark: "หมายเหตุ",
        reason_to_cancel: 'เหตุผลการยกเลิกการสมัคร',
        announcement: 'ประกาศรับสมัคร',
        additional_info: 'ข้อมูลเพิ่มเติม',
        additional_info_graduate: 'คุณสมบัติผู้สมัคร',
        study_admit_type: 'ประเภทรับเข้า',
        study_plan: 'แผนการศึกษา',
        study_classes: 'ช่วงเวลาเรียน',
        specific_nation: 'เฉพาะ',
        no_result: 'ไม่มีรายการ',
    },
    announcement: {
        announcement_main: 'หน้าประกาศหลัก',
        announcement: 'ข่าว/ประกาศ/ประชาสัมพันธ์',
        announcement_tcas: 'หน้าประกาศ TCAS',
        announcement_inter: "หน้าประกาศ International Program",
        announcement_con: "หน้าประกาศ หลักสูตรต่อเนื่อง",
        announcement_premium: "หน้าประกาศ หลักสูตรอาชีวะพรีเมียม",
        announcement_special: "หน้าประกาศ รอบพิเศษ",

        application_announcement: 'ประกาศรับสมัคร',
        writing_information: 'ผู้มีสิทธิ์สอบข้อเขียน/ปฏิบัติ',
        interview_information: 'ผู้มีสิทธิ์สอบสัมภาษณ์',
        clearing_house: 'ผู้มีสิทธิ์เคลียริงเฮาส์',
        qualified: 'ผู้มีสิทธิ์เข้าศึกษา',
        matriculation: 'การรายงานตัว',
        title: 'หัวข้อ/เรื่อง',
        detail: 'รายละเอียด',
        swift: 'เลื่อน >> สำหรับข้อมูลเพิ่มเติม'
    },
    announcement_graduate: {
        announcement_main: 'หน้าประกาศหลัก',
        announcement: 'ข่าว/ประกาศ/ประชาสัมพันธ์',
        announcement_pdf_file: 'เอกสารดาวน์โหลด',
        announcement_master: 'หน้าประกาศหลักสูตรระดับปริญญาโท',
        announcement_inter: "หน้าประกาศหลักสูตรอินเตอร์",
        announcement_doctor: "หน้าประกาศหลักสูตรระดับปริญญาเอก",
        announcement_future_innovators: "หน้าประกาศโครงการแววนวัตกร",

        application_announcement: 'ประกาศรับสมัคร',
        writing_information: 'ผู้มีสิทธิ์สอบข้อเขียน/ปฏิบัติ',
        interview_information: 'ผู้มีสิทธิ์สอบสัมภาษณ์',
        qualified: 'ผู้มีสิทธิ์เข้าศึกษา',
        confirm_pay: 'ผู้ยืนยันสิทธิ์',
        title: 'หัวข้อ/เรื่อง',
        detail: 'รายละเอียด',
    },
    registered_program_list: {
        title: 'รายการที่สมัคร',
        announcement: 'ประกาศรับสมัคร / ประกาศรายชื่อผู้มีสิทธิ์สอบ / ประกาศอื่นๆ',
        round: 'รอบที่',
        open_date: 'วันที่เปิดรับสมัคร',
        registration_no: 'เลขที่สมัคร',
        application_document: 'ใบสมัคร',
        faculty: 'คณะ',
        curriculum: 'หลักสูตร',
        branch: 'แขนง',
        no: 'ลำดับที่',
        close: 'ปิด',
        academic_year: 'ปีการศึกษา',
        project_application: 'ใบสมัครโครงการ',
        curriculum_to_apply: 'หลักสูตรที่สมัคร',
        not_completed_all_information: 'กรอกข้อมูลยังไม่ครบ',
        completed_the_application: 'กรอกข้อมูลการสมัครครบแล้ว',
        print_pay_in_process: 'พิมพ์ใบชำระเงินค่าสมัคร/อยู่ระหว่างการจ่าย',
        verify_within_3_days: 'หากจ่ายแล้ว ระบบจะใช้เวลาตรวจสอบ 3 วันทำการ (เมื่อพ้นเวลาตรวจสอบแต่สถานะการจ่ายเงินไม่เปลี่ยน กรุณาติดต่อเจ้าหน้าที่ภายใน 1 วันทำการเพื่อตรวจสอบ)',
        payment_can_be_made_since: 'ชำระได้ตั้งแต่วันที่',
        to: 'ถึง',
        print_pay_in_slip: 'พิมพ์ใบชำระเงิน',
        application_paid: 'จ่ายค่าสมัครแล้ว',
        did_not_make_payment_in_time: 'ไม่ชำระเงินในเวลาที่กำหนด',
        announcement_selection_result: 'ผลการคัดเลือก',
        result_has_not_been_announced: 'ยังไม่ประกาศผล',
        result_announced: 'ประกาศที่เมนู →',
        result_announced_1: 'รวมประกาศ | ปริญญาตรี',
        result_announced_2: 'รวมประกาศ | บัณฑิตศึกษา',
        according_announced: ' ตามวันที่กำหนด',
        pass: 'ผ่าน',
        not_pass: 'ไม่ผ่าน',
        announcement_CH_result: 'ผลการ Clearing House',
        select: 'เลือก',
        not_select: 'ไม่เลือก',
        print_payment_slip_assertion_in_process_assertion: 'พิมพ์ใบชำระเงินค่ายืนยันสิทธิ์/อยู่ระหว่างการยืนยันสิทธิ์',
        already_assertion: 'ยืนยันสิทธิ์แล้ว',
        cancel_application: 'ยกเลิกการสมัคร',
        canceled_application_list: 'รายการที่ยกเลิกการสมัครแล้ว',
        canceled_project_application: '(ยกเลิกแล้ว) ใบสมัครโครงการ',
        canceled_from_date: 'ยกเลิกเมื่อ',
        reason_for_cancellation: 'สาเหตุการยกเลิกที่ระบุไว้',
        cancellation_application_no: 'ยกเลิกใบสมัครเลขที่',
        cancel_this_application_if_you_have_paid_application_fee: 'การยกเลิกรายการสมัครนี้ หากนักศึกษาชำระเงินค่าสมัครไว้แล้ว',
        system_not_refund_application_fee_students: 'ระบบจะไม่คืนเงินค่าสมัครให้นักศึกษา',
        if_student_would_like_cancel_application: 'หากนักศึกษาต้องการยกเลิกการรับสมัคร',
        please_fill_reason_for_cancellation_box_below: 'กรุณากรอกสาเหตุการยกเลิกที่ช่องด้านล่างนี้',
        confirm_cancel_application: 'ยืนยันการยกเลิกการสมัคร',
        print_payin_slip_kbank: 'พิมพ์ใบชำระเงิน (ชำระเข้าบัญชีธนาคารกสิกรไทย)',
        print_payin_slip_scb: 'พิมพ์ใบชำระเงิน (ชำระเข้าบัญชีธนาคารไทยพาณิชย์)',
        additional_documents: 'เอกสารประกอบการสมัคร (ถ้ามี)',
    },
    project_file_upload: {
        upload_only_specify: 'อัปโหลดไฟล์หลักฐาน / เอกสารประกอบการสมัคร (ตามประกาศ เฉพาะหลักสูตรที่ระบุ เท่านั้น)',
        file_size: 'ผู้สมัครสามารถอัปโหลดเอกสารประกอบการสมัครได้ 1 ไฟล์ เป็น PDF ขนาดไม่เกิน 4 MB',
        detail: '(ถ้ามีเอกสารอัปโหลดมากกว่า 1 ไฟล์ ให้ผู้สมัครต่อหน้า PDF มาเป็นไฟล์เดียว)',
        upload_file: 'อัปโหลดไฟล์',
        uploaded_file: 'ไฟล์ที่อัปโหลดแล้ว',
        no_file_uploaded: 'ไม่มีไฟล์ที่อัปโหลด',
        view: 'เรียกดู',
        delete: 'ลบ',
        confirm_delete_file: 'ยืนยันการลบไฟล์',
        upload: 'Upload',
    },
    confirm_regis: {
        confirm_regis: 'ยืนยันการสมัคร',
        project: 'โครงการ',
        round: 'รอบที่',
        academic_year: 'ปีการศึกษา',
        alert: 'คุณได้ทำการสมัครในโครงการนี้ไปแล้ว หากต้องการสมัครใหม่จำเป็นต้องยกเลิกโครงการที่สมัครเดิมก่อน โดยสามารถทำรายการยกเลิกได้ที่หน้า',
        registered_program_list: 'รายการที่สมัคร',
        fill_in_all_fields: 'เลือกหลักสูตรด้านล่างนี้ให้ครบจำนวน',
        no: 'ลำดับที่',
        icon_remark1: 'กลุ่มวิชา Hot เลือกได้เพียงสาขาเดียว',
        icon_remark2: 'เรียนที่จังหวัดชุมพร',
        remark: 'หมายเหตุ',
        remark_payment_kmitl: 'กรณีเปลี่ยนสาขาวิชาที่สมัครหรืออันดับหรือโครงการที่สมัคร ต้องสมัครใหม่ และชำระเงินค่าสมัครใหม่เท่านั้น โดยสถาบันฯ จะถือว่าการสมัครครั้งสุดท้ายที่มีการชําระเงินค่าสมัครเรียบร้อยแล้วเป็นครั้งที่ต้องการเข้าสอบ และครั้งที่สมัครก่อนหน้าจะถือเป็นโมฆะ แม้ว่าจะชําระเงินค่าสมัครแล้วก็ตาม',
        remark_payment_ch_1: '1. ผู้ผ่านการคัดเลือกในสาขาของวิทยาเขตชุมพรเขตรอุดมศักดิ์ จังหวัดชุมพร ยอมรับที่จะต้องไปเรียนที่วิทยาเขตชุมพรเขตรอุดมศักดิ์ จังหวัดชุมพร ตลอดการศึกษาตั้งแต่ชั้นปีที่ 1 ถึงชั้นปีที่ 4',
        remark_payment_ch_2: '2. ผลการคัดเลือกถือเป็นสิทธิ์ชี้ขาดของวิทยาเขตชุมพรเขตรอุดมศักดิ์ สถาบันเทคโนโลยีพระจอมเกล้าเจ้าคุณทหารลาดกระบัง',
        remark_payment_ch_3: '3. กรณีเปลี่ยนสาขาวิชาที่สมัครหรืออันดับหรือโครงการที่สมัคร ต้องสมัครใหม่ และชำระเงินค่าสมัครใหม่เท่านั้น โดยสถาบันฯ จะถือว่าการสมัครครั้งสุดท้ายที่มีการชําระเงินค่าสมัครเรียบร้อยแล้วเป็นครั้งที่ต้องการเข้าสอบ และครั้งที่สมัครก่อนหน้าจะถือเป็นโมฆะ แม้ว่าจะชําระเงินค่าสมัครแล้วก็ตาม',
        regis: 'สมัคร',
        close: 'ปิด',
        symbol_explanation: 'คำอธิบายสัญลักษณ์',
        study_plan: 'แผน',
        study_class: 'ช่วงเวลาเรียน',
    },
    applicantInfo_medical: {
        educational_background: 'ประวัติการศึกษา',
        test_date: 'วันที่สอบ',
        standard_academic_test: 'ผลการสอบวัดความสามารถทางวิชาการ',
        SAT1_subject_test: 'SAT I',
        total: 'Total',
        reading_writing: 'Reading Writing',
        OldSAT_subject_test: 'OLD SAT',
        verbal: 'Verbal',
        writing: 'Writing',
        SAT2_subject_test: 'SAT II',
        biology: 'Biology',
        chemistry: 'Chemistry',
        physics: 'Physics',
        mathematics: 'Mathematics',
        bioMedical_admission_test: 'BioMedical Admission Test (BMAT)',
        section1: 'Section 1',
        section2: 'Section 2',
        section3: 'Section 3',
        SPOT_score: 'คะแนน กสพท',
        english_proficiency_test: 'ผลการสอบวัดความสามารถในการสื่อสารภาษาอังกฤษ',
        TOEFL_paper_based: 'TOEFL (Paper based)',
        TOEFL_computer_based: 'TOEFL (Computer based)',
        TOEFL_internet_based: 'TOEFL (Internet based)',
        IELTS_academic_module: 'IELTS (Academic Module)',
        CU_TEP: 'CU-TEP',
        personal_statement: '** Personal statement (In English, less than 1000 words) **',
    },
    applicantInfo_engInter: {
        AP_IB_IGCSE_test_score: 'AP/IB/IGCSE TEST SCORE',
        subject_1_name: 'Subject #1 name',
        subject_1_score: 'Subject #1 score',
        subject_1_test_date: 'Subject #1 test date',
        subject_2_name: 'Subject #2 name',
        subject_2_score: 'Subject #2 score',
        subject_2_test_date: 'Subject #2 test date',
        subject_3_name: 'Subject #3 name',
        subject_3_score: 'Subject #3 score',
        subject_3_test_date: 'Subject #3 test date',
        GED: 'GED',
        GED_RTLA_score: 'Reasoning Through Language Arts',
        GED_MR_score: 'Mathematical Reasoning',
        GED_SCI_score: 'Science',
        GED_SS_score: 'Social Studies',
    },
    toasted: {
        save_successfully: 'บันทึกสำเร็จ',
        cannot_save: 'บันทึกไม่สำเร็จ',
        create_successfully: 'เพิ่มสำเร็จ',
        cannot_create: 'เพิ่มไม่สำเร็จ',
        cannot_upload_file: 'อัปโหลดไฟล์ไม่สำเร็จ',
        delete_successfully: 'ลบสำเร็จ',
        cannot_delete: 'ลบไม่สำเร็จ',
        edit_successfully: 'แก้ไขสำเร็จ',
        cannot_edit: 'แก้ไขไม่สำเร็จ',
        mail_sent: 'ส่งอีเมลแล้ว',
        mail_sent_to: 'ส่งอีเมลแล้ว กรุณาตรวจสอบที่',
    },
    info_card: {
        name_surename: 'ชื่อ - สกุล',
        prename: 'คำนำหน้าชื่อ',
        name_th: 'ชื่อ (ภาษาไทย)',
        surname_th: 'นามสกุล (ภาษาไทย)',
        name_th_hint: 'เฉพาะชาวต่างชาติที่ไม่มีชื่อภาษาไทยให้กรอกชื่อภาษาอังกฤษ',
        surname_th_hint: 'เฉพาะชาวต่างชาติที่ไม่มีนามสกุลภาษาไทยให้กรอกนามสกุลภาษาอังกฤษ',
        name_en: 'ชื่อ (ภาษาอังกฤษ ตัวพิมพ์ใหญ่เท่านั้น)',
        surname_en: 'นามสกุล (ภาษาอังกฤษ ตัวพิมพ์ใหญ่เท่านั้น)',
        all_gpa: 'คะแนน GPA รวม (GPAX) [กรอกที่เมนู ข้อมูลการศึกษา (โรงเรียน)]',
        math_credit: 'หน่วยกิต วิชาคณิตศาสตร์',
        math_gpa: 'GPA วิชาคณิตศาสตร์',
        physics_credit: 'หน่วยกิต วิชาฟิสิกส์',
        physics_gpa: 'GPA วิชาฟิสิกส์',
        science_credit: 'หน่วยกิต วิชาวิทยาศาสตร์',
        science_gpa: 'GPA วิชาวิทยาศาสตร์',
        chemistry_credit: 'หน่วยกิต วิชาเคมี',
        chemistry_gpa: 'GPA วิชาเคมี',
        bio_credit: 'หน่วยกิต วิชาชีววิทยา',
        bio_gpa: 'GPA วิชาชีววิทยา',
        thai_credit: 'หน่วยกิต วิชาภาษาไทย',
        thai_gpa: 'GPA วิชาภาษาไทย',
        english_credit: 'หน่วยกิต วิชาภาษาอังกฤษ',
        english_gpa: 'GPA วิชาภาษาอังกฤษ',
        science_math_credit: 'หน่วยกิต วิชาวิทยาศาสตร์ และ คณิตศาสตร์',
        science_math_gpa: 'GPA วิชาวิทยาศาสตร์ และ คณิตศาสตร์',
        foreign_credit: 'หน่วยกิต วิชาภาษาต่างประเทศ',
        foreign_gpa: 'GPA วิชาภาษาต่างประเทศ',
        GAT: 'คะแนน GAT',
        PAT: 'คะแนน PAT',
        math_phy_chem_eng_gpa: 'GPA 4 วิชา (คณิตศาสตร์, ฟิสิกส์, เคมี, อังกฤษ)',
        math_physics_gpa: 'GPA วิชาคณิตศาสตร์และฟิสิกส์)',

        english_exam: 'มาตรฐานความรู้ภาษาอังกฤษ',
        score: 'คะแนน',
        english_exam_hint: 'ผลการสอบมาตรฐานความรู้ภาษาอังกฤษต้องมีอายุไม่เกิน 2 ปี',
        english_exam_result_file: 'ไฟล์ผลสอบภาษาอังกฤษ (TOEFL, IELTS, CU-TEP, TU-GET)',
        academic_exam_result_file: 'ไฟล์ผลสอบวิชาการ (SAT)',
        essay_file: 'ไฟล์เขียนเรียงความ',

        address_registration: "ที่อยู่ตามทะเบียนบ้าน",
        address_contact: "ที่อยู่ที่สามารถติดต่อได้",
        house_id: "เลขรหัสประจำบ้าน (ดูในเล่มทะเบียนบ้าน กรอกเฉพาะตัวเลข 11 หลัก)",
        house_number: "บ้านเลขที่",
        village_name: "ชื่อหมู่บ้าน",
        moo: "หมู่ที่",
        soi: "ซอย",
        street: "ถนน",
        province: "จังหวัด",
        district: "อำเภอ",
        sub_district: "ตำบล",
        in_thai: "ในประเทศไทย",
        foreign_country: "ต่างประเทศ",
        country: "ประเทศ",
        other: "อื่นๆ เช่น GED",

        personal_information: "ข้อมูลผู้สมัคร",
        citizen_id: "รหัสบัตรประจำตัวประชาชน",
        citizen_id_passport: "รหัสบัตรประจำตัวประชาชน / หนังสือเดินทาง",
        thai: "ชาวไทย",
        foreigner: "ชาวต่างชาติ",
        nation_thai: "สัญชาติไทย",
        nation_foreigner: "สัญชาติอื่นๆ",
        fill_thai_citizenID: "กรอกเลขบัตรประชาชนไทย",
        fill_passport_number: "กรอกเลขบัตรพาสปอร์ต",
        passport_number: "เลขที่หนังสือเดินทาง",
        passport_start_date: "วันออกหนังสือเดินทาง",
        passport_end_date: "วันหมดอายุของหนังสือเดินทาง",
        birthday: "วันเกิด",
        mobile: "เบอร์โทรศัพท์",
        email: "Email",
        blood_type: "กรุ๊ปเลือด",
        race: "เชื้อชาติ",
        nation: "สัญชาติ",
        religion: "ศาสนา",
        father_info: "ข้อมูลบิดา",
        mother_info: "ข้อมูลมารดา",

        education_background_undergrad: "ประวัติการศึกษาที่ผ่านมา (สำหรับสมัครระดับปริญญาตรี)",
        education_background_grad: "ประวัติการศึกษาที่ผ่านมา (สำหรับสมัครระดับบัณฑิตศึกษา)",
        school_location: "ที่ตั้งโรงเรียน",
        university_location: "ที่ตั้งมหาวิทยาลัย",
        university_name: "ชื่อมหาวิทยาลัย",
        school_name: "ชื่อโรงเรียน",
        add_school: "หากไม่มีชื่อโรงเรียนในตัวเลือก กรุณส่งข้อมูล'ชื่อ'และ'ที่อยู่'ของโรงเรียนมาที่อีเมล : admission-reg@kmitl.ac.th",
        add_university: "หากไม่มีชื่อมหาวิทยาลัยในตัวเลือก กรุณส่งข้อมูล'ชื่อ'และ'ที่อยู่'ของมหาวิทยาลัยมาที่อีเมล : grad-reg@kmitl.ac.th)",
        school_type: "ประเภทโรงเรียน",
        education_type: "แผนการศึกษา",
        education_other: "แผนการศึกษาอื่นๆ",
        education_other_hint: "ระบุแผนการศึกษา",
        school_student_id: "เลขที่ประจำตัวนักเรียน หรือ รหัสประจำตัวนักเรียน",
        school_grad_date: "วันที่สำเร็จการศึกษา",
        school_grad_date_detail: "*วันที่สำเร็จการศึกษา ต้องตรงกับเอกสารสำเร็จการศึกษาที่ยื่นต่อสถาบันฯ",
        study_status: "สถานะภาพทางการศึกษา",
        study_type: "ประเภทการศึกษา",
        number_of_GPA_term: "จำนวนเทอมของ GPA",
        GPA: "คะแนน GPA รวม (GPAX)",
        GPA_hint: "หากไม่มี GPA ให้ใส่ค่า 0.00 / หาก GPA มากกว่า 4.00 ให้ใส่ค่า 4.00",
        graduated_year: "ปีที่สำเร็จการศึกษา (พ.ศ.)",
        undergraduate_education_history: "ข้อมูลประวัติการศึกษาระดับปริญญาตรี",
        university_study_status: "สถานภาพการศึกษา",
        degree_name: "คุณวุฒิ/ปริญญา",
        curriculum_name: "สาขา",
        graduate_education_history: "ข้อมูลประวัติการศึกษาระดับปริญญาโท",
        graduate_working_experience: "ประสบการณ์การทำงาน (ถ้ามี)",
        num_year_working_experience: "จำนวนปีที่ทำงาน",
        company_name: "บริษัทที่ทำงาน (1)",
        company_name1: "บริษัทที่ทำงาน (2)",
        position_in_company: "ตำแหน่ง",
        since_working: "เริ่มทำงานตั้งแต่ปี พ.ศ.",

        information_for_the_course: "ข้อมูลสำหรับประกอบหลักสูตรที่สมัคร",
        information_for_the_course_grad: "ข้อมูลสำหรับประกอบหลักสูตรที่สมัคร (หลักสูตรระดับบัณฑิตศึกษา)",

        checkbox_1: "โปรดตรวจสอบคุณสมบัติของผู้สมัคร จากประกาศรับสมัครของแต่ละคณะ/วิทยาลัย/วิทยาเขต ว่ามีคุณสมบัติ และ ",
        checkbox_2: "ต้องกรอกข้อมูลในระบบให้ครบถ้วนก่อนการสมัคร ",
        checkbox_3: " หากสถาบันฯ ตรวจข้อมูลพื้นฐานเบื้องต้นจากในระบบแล้วพบว่าผู้สมัครไม่มีคุณสมบัติตามประกาศ สถาบันฯ สงวนสิทธิ์ไม่พิจารณาในสาขาที่สมัคร ",
        checkbox_4: "(ตัดสิทธิ์) ",
        checkbox_5: "และจะไม่คืนเงินค่าสมัครให้ไม่ว่ากรณีใด ๆ",
        announcement: 'ประกาศรับสมัคร  >> คลิก',
        here: 'ที่นี่',

        history_title: 'ประวัติการกรอก/แก้ไข',
        history_type: 'ประเภท',
        history_value: 'ค่าที่กรอก/แก้ไข',
        history_date: 'วันที่กรอก/แก้ไข',
        history_no_item: 'ไม่มีประวัติการกรอก/แก้ไข',
    },
    officer_config: {
        addnew: "เพิ่มใหม่",
        edit: "แก้ไข",
        delete: "ลบ",
        save: "บันทึก",
        confirm: "ยืนยัน",
        cancel: "ยกเลิก",
        //config_year
        config_year: "ตั้งค่าปีการศึกษาที่เปิดรับ",
        academic_year: "ปีการศึกษา",
        semester: "ภาคการศึกษา",
        academic_level: "ระดับการศึกษา",
        admit_date: "วันเข้าศึกษา (ของนักศึกษา)",
        start_using_date: "วันที่เริ่มใช้ปีการศึกษานี้",
        //config_faculty_bank_account
        config_faculty_bank_account: "ตั้งค่าบัญชีธนาคารคณะ",
        faculty: "คณะ",
        bank_account_number: "เลขบัญชี",
        bank_name_th: "ชื่อธนาคาร (ภาษาไทย)",
        bank_name_en: "ชื่อธนาคาร (ภาษาอังกฤษ)",
        bank_info_th: "ข้อมูลธนาคาร (ภาษาไทย)",
        bank_info_en: "ข้อมูลธนาคาร (ภาษาอังกฤษ)",
        bank_logo: "Logo ธนาคาร",
        service_charge: "Service charge",
        //config_round
        config_round: "ตั้งค่ารอบการสมัคร",
        year_semester_level: "ปี/เทอม(ระดับ)", //เป็น Dropdown จากตาราง CONFIG_YEAR
        round_number: "เลขที่รอบ เช่น (1 หรือ 2)",
        round_name_th: "ชื่อรอบ (ภาษาไทย)",
        round_name_en: "ชื่อรอบ (ภาษาองกฤษ)",
        round_start_date: "วันเริ่มการรับ",
        round_end_date: "วันสิ้นสุดการรับ",
        //config_project
        config_project: "ตั้งค่าโครงการ",
        round_number_name: "รอบ-ชื่อรอบ",
        project_code: "รหัสโครงการ",
        project_name_th: "ชื่อโครงการ (ภาษาไทย)",
        project_name_en: "ชื่อโครงการ (ภาษาอังกฤษ)",
        number_of_ranks: "อันดับหลักสูตรที่เลือกได้",
        enabled: "แสดงในหน้าค้นหาหลักสูตร",
        //config_curriculum
        tcas_program_id: 'รหัสหลักสูตร TCAS',
        config_curriculum: "ตั้งค่าหลักสูตรที่เปิดรับสมัคร",
        project_name: "โครงการ",
        curriculum_name: "หลักสูตร/สาขา", //Backend จะเอาหลักสูตรมาแสดงจาก DB:registrar โดย ป.ตรีเอา curr2_id มา/บัณฑิตเอา curr_id มา
        tuition_fee: "ค่ายืนยันสิทธิ์ (ค่าเทอม)",
        application_fee: "ค่าสมัคร", //Backend จะเอาหลักสูตรมาแสดงจาก DB:registrar โดยเป็นการแสดงปกติ ไม่ให้ จนท.แก้ไขได้
        start_application_date: "วันเริ่ม การรับสมัคร",
        end_application_date: "วันสุดท้าย การรับสมัคร",
        start_application_pay_date: "วันเริ่ม การจ่ายค่าสมัคร",
        end_application_pay_date: "วันสุดท้าย การจ่ายค่าสมัคร",
        start_confirm_date: "วันเริ่ม การยืนยันสิทธิ์",
        end_confirm_date: "วันสุดท้าย การยืนยันสิทธิ์",
        start_confirm_pay_date: "วันเริ่ม การจ่ายค่ายืนยันสิทธิ์",
        end_confirm_pay_date: "วันสุดท้าย การจ่ายค่ายืนยันสิทธิ์",
        applicant_can_upload_file: "ผู้สมัครสามารถอัปโหลดไฟล์",
        attach_PDF_if_any: "แนบ PDF ข้อมูลเพิ่มเติม (ถ้ามี)",
        attach_URL_if_any: "แนบ URL ข้อมูลเพิ่มเติม (ถ้ามี)",
        remark_if_any: "หมายเหตุ (ถ้ามี)",
        delete_file: "ลบไฟล์ PDF",
        branch_if_any: 'แขนง (ถ้ามี)',
        admit_type: 'ประเภทรับเข้า',
        study_plan: 'แผนการศึกษา',
        study_classes: 'ช่วงเวลาเรียน',
        specific_nation: 'กำหนดเฉพาะสัญชาตินักศึกษา (ถ้ามี)',
        //config_curriculum_constraint
        round: 'รอบ',
        close: 'ปิด',
        constraint: 'เงื่อนไขของหลักสูตร',
        config_curriculum_constraint: "ตั้งค่าเงื่อนไขของหลักสูตรที่เปิดรับสมัคร",
        constriant_value: 'ค่าที่กำหนด',
        copy: 'คัดลอก',
        paste: 'วาง',
        finish: 'เสร็จสิ้น',
        number_of_order_allow: "จำนวนอันดับที่อนุญาตให้เลือกได้",
        english_exam_result: 'ไฟล์ผลสอบภาษาอังกฤษ (TOEFL, IELTS, CU-TEP, TU-GET)',
        academic_exam_result: 'ไฟล์ผลสอบวิชาการ (SAT)',
        essay: 'ไฟล์เขียนเรียงความ',
        minimum_gpa_applicable: "GPA ต่ำสุดที่สมัครได้",
        minimum_number_of_semester: "จำนวนเทอมต่ำสุดของ GPA",
        gat_score: "คะแนน GAT",
        pat_score: "คะแนน PAT",
        math_credit: 'หน่วยกิต วิชาคณิตศาสตร์',
        math_gpa: 'GPA วิชาคณิตศาสตร์',
        physics_credit: 'หน่วยกิต วิชาฟิสิกส์',
        physics_gpa: 'GPA วิชาฟิสิกส์',
        science_credit: 'หน่วยกิต วิชาวิทยาศาสตร์',
        science_gpa: 'GPA วิชาวิทยาศาสตร์',
        chemistry_credit: 'หน่วยกิต วิชาเคมี',
        chemistry_gpa: 'GPA วิชาเคมี',
        english_credit: 'หน่วยกิต วิชาภาษาอังกฤษ',
        english_gpa: 'GPA วิชาภาษาอังกฤษ',
        science_math_credit: 'หน่วยกิต วิชาวิทยาศาสตร์ และ คณิตศาสตร์',
        science_math_gpa: 'GPA วิชาวิทยาศาสตร์ และ คณิตศาสตร์',
        foreign_credit: 'หน่วยกิต วิชาภาษาต่างประเทศ',
        foreign_gpa: 'GPA วิชาภาษาต่างประเทศ',
        math_physics_chemistry_english_gpa: 'GPA 4 วิชา (คณิตศาสตร์, ฟิสิกส์, เคมี, อังกฤษ)',
        math_physics_gpa: 'GPA วิชาคณิตศาสตร์และฟิสิกส์',
        application_date: 'วันเปิดรับสมัคร',
        application_pay: 'วันชำระเงิน',
        branch: 'แขนง',
        curriculum: 'หลักสูตร',
    },
    questionnaire: {
        title: "ประเมินแบบสอบถามความพึงพอใจ ระบบรับสมัครนักศึกษา",
        general_information: "ข้อมูลทั่วไปของผู้ตอบแบบสอบถาม",
        birthplace: "ภูมิลำเนาของท่าน",
        news_source: "ท่านทราบข่าวการสมัครจาก",
        news_source_specify: "โปรดระบุแหล่งข่าว",
        device: "ท่านใช้ระบบรับสมัครส่วนใหญ่ด้วย",
        internet_used: "การใช้อินเตอร์เน็ตส่วนใหญ่",
        internet_used_specify: "โปรดระบุข้อมูลอินเตอร์เน็ต",

        level_satisfaction_user: "ระดับความพึงพอใจของผู้รับบริการ",
        please_fill_in_truth: "*** กรุณากรอกตามความจริง เพื่อใช้เป็นข้อมูลในการปรับปรุงระบบและบริการ ***",
        header_table1: "คุณลักษณะ",
        header_table2: "ระดับ",
        header_table2_hint: "(1:พึงพอใจน้อยมาก ถึง 5:พึงพอใจมากที่สุด)",
        Q1: "1. ด้านกระบวนการ (Process)",
        Q1_1: "1.1 ความง่าย (User Friendly) ในการใช้งานระบบ",
        Q1_2: "1.2 ความเหมาะสม ของขั้นตอนการรับสมัคร",
        Q1_3: "1.3 ความเหมาะสม ของขั้นตอนการบันทึก ข้อมูลพื้นฐาน",
        Q1_4: "1.4 ความเหมาะสม ในการประชาสัมพันธ์ การรับสมัคร",
        Q1_5: "1.5 ท่านคิดว่าระบบการรับสมัครครั้งนี้ สมบูรณ์เพียงใด",
        Q2: "2. ด้านคุณภาพของเนื้อหา (Content)",
        Q2_1: "2.1 ความสะดวก ในการเชื่อมโยงข้อมูล ภายในเว็บไซต์",
        Q2_2: "2.2 ความรวดเร็วในการเข้าถึงเว็บไซต์",
        Q2_3: "2.3 ความเหมาะสมของข้อมูลภายในเว็บไซต์",
        Q2_4: "2.4 ความถูกต้องครบถ้วนของข้อมูล",
        Q3: "3. ด้านการออกแบบและการจัดรูปแบบ (Design)",
        Q3_1: "3.1 ความสวยงาม ความทันสมัย น่าสนใจของหน้าเว็บไซต์",
        Q3_2: "3.2 การจัดรูปแบบ ในเว็บไซต์ง่าย ต่อการอ่าน และการใช้งาน",
        Q3_3: "3.3 ขนาดและรูปแบบตัวอักษร อ่านได้ง่ายและสวยงาม",
        Q3_4: "3.4 ความเร็วในการแสดงภาพ ตัวอักษร และข้อมูลต่าง ๆ",

        additional_info: "ข้อมูลเพิ่มเติม",
        additional_1: "แนวทางการปรับปรุงโปรแกรม/ พัฒนาระบบ/ สิ่งที่คาดหวัง",
        additional_2: "ท่านต้องการสิ่งใดเพิ่มเติม เพื่อช่วยท่านในการเข้าศึกษาต่อ",
        additional_3: "ข้อเสนอแนะเพิ่มเติม/ ข้อเสนอแนะอื่นๆ",
    },
    applicant_info_add: {
        title: "ข้อมูลเพิ่มเติม (สำหรับแสดงในใบสมัคร)",
        address: "ที่อยู่",
        user_detail_1: "เหตุผลในการเข้าศึกษา สจล.",
        user_detail_2: "ความสามารถพิเศษด้านภาษาอังกฤษ",
        user_detail_3: "ความสามารถพิเศษ",
        user_detail_4: "ประวัติการได้ทุน",
        user_detail_5: "ประวัติการแข่งกีฬา",
        user_detail_6: "ประวัติการอบรม / แข่งขัน / สอวน.",
        fill_data: "กรอกข้อมูลเพิ่มเติมในใบสมัคร เช่น ที่อยู่, เหตุผลในการเข้าสมัคร, ความสามารถพิเศษ ฯลฯ <<คลิก>>",
        click_to_print: "Click ที่นี่เพื่อพิมพ์ใบสมัคร",
        please_fill_to_able_print: "กรุณากรอกข้อมูลที่อยู่ในปุ่มด้านล่างก่อน จึงจะสามารถพิมพ์ใบสมัครได้",
    },
    number_of_applicants_report: {
        title: "รายงาน",
        all_project: "รวมทุกโครงการ",
        curriculum: "สาขา / หลักสูตร",
        not_complete_information: "ยังกรอกข้อมูลไม่ครบ",
        waiting_to_pay_application_fee: "รอจ่ายเงินค่าสมัคร",
        application_fee_paid: "จ่ายเงินค่าสมัครแล้ว",
        summary: "สรุป",
    },
    number_of_applicants_by_order_report: {
        title: "รายงานแยกลำดับสาขา + คัดเลือก",
        select_order_1: "เลือกเป็นอันดับ 1 (ใบสมัคร)",
        select_order_2: "เลือกเป็นอันดับ 2 (ใบสมัคร)",
        select_order_3: "เลือกเป็นอันดับ 3 (ใบสมัคร)",
        branch: "แขนง",
    },
    applicants_report_list: {
        title: "รายงาน",
        passed_title: "รายงานผู้ผ่านการคัดเลือก",
        year: "ปีการศึกษา",
        round: "รอบ",
        project: "โครงการ",
        faculty: "คณะ",
        curriculum: "หลักสูตร",
        branch: "แขนง",
        type_data: "ประเภทข้อมูล",
        registration_no: "เลขที่ผู้สมัคร",
        name_surname: "ชื่อ - นามสกุล",
        applied_timestamp: "วันเวลากดประกาศ",
        citizen_id: "รหัสบัตรประชาชน",
        email: "Email",
        mobile: "Mobile",
        school: "โรงเรียน",
        notice: "หมายเหตุ",
        total: "ทั้งหมด",
        person: "คน",
        unit: "(ใบสมัคร)",
        file_upload: "ไฟล์อัปโหลด",
        address: "ที่อยู่",
        order_1: "สาขาที่เลือกอันดับ 1",
        order_2: "สาขาที่เลือกอันดับ 2",
        order_3: "สาขาที่เลือกอันดับ 3",
    },
};